import OrderCreate from '@/pages/v3/OrderCreate'

export default [
  {
    path: '/app/v3/order/create',
    name: 'order_create',
    component: OrderCreate,
  }
]
